import {mapActions, mapGetters, mapMutations} from "vuex";

import homeSlider from '@/modules/home/slider/index.vue'
import filters from '@/components/filters/index.vue'
import propertiesGrid from '@/components/properties-grid/index.vue'
import filtersCustom from '@/components/filters-custom/index.vue'
import homeHeaderIcon from '@/modules/home/head-icon/index.vue'
import _ from "lodash";

export default {
  name: 'home',
  //---components
  components: {
    filters,
    propertiesGrid,
    filtersCustom,
    homeSlider,
    homeHeaderIcon
  },
  //---data
  data () {
    return {
      perPageForListings: 6,
    }
  },
  //---hooks
  created: function () {
    let promiseCollection = [];

    let getListingsRequest = this.getListings({filters: this.$route.query, perPage: 6});
    promiseCollection.push(getListingsRequest);

    if (this.filtersScheme === null) {
      let getSchemeFiltersRequest = this.getSchemeFilters();
      promiseCollection.push(getSchemeFiltersRequest);
    }

    if (promiseCollection.length > 0 ) {
      this.loaderFlag(true);
      Promise.all(promiseCollection).finally(()=> {
        this.loaderFlag(false);
      })
    }
  },
  computed: {
    ...mapGetters({
      filtersMeta: 'FILTERS/filtersMeta',
      filtersScheme: 'FILTERS/filtersScheme',
    })
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      getSchemeFilters: 'FILTERS/FILTERS_SCHEME_REQUEST_GET',
      getListings: 'FILTERS/FILTERS_LISTINGS_REQUEST_GET'
    }),
    filtersChange(filter) {
      this.loaderFlag(true);

      this.$router.push({
        name: 'home',
        query: filter
      })
      this.getListings({filters: filter, perPage: 6}).finally(()=> {
        this.loaderFlag(false);
      });
    },
    filtersCustomChange(filter) {
      this.$router.push({
        name: 'properties',
        query: Object.assign({},filter)
      })
    },
  }
}
